import { Provider as MobxProvider } from 'mobx-react';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { ThemeProvider as StyledComponentsProvider } from 'styled-components';
import { ThemeProvider as MuiProvider, StylesProvider } from '@material-ui/core/styles';

import PublicEnv from 'shared/utils/public-env';
import { appState } from 'src/state/app';
import DutchieRouter from 'src/routes';
import Ernie from 'shared/components/ernie';
import { styledComponentsTheme } from 'shared/themes';
import { PendoAnalytics } from 'src/utils/pendo';
import { GlobalStyles, adminMuiTheme } from './styles';

function Root(): JSX.Element {
  return (
    <MobxProvider {...appState.stores()}>
      <ApolloProvider client={appState.apolloClient}>
        <StyledComponentsProvider theme={styledComponentsTheme}>
          <MuiProvider theme={adminMuiTheme}>
            <StylesProvider injectFirst>
              <>
                <GlobalStyles />
                <PendoAnalytics />
                <DutchieRouter />
                <Ernie />
              </>
            </StylesProvider>
          </MuiProvider>
        </StyledComponentsProvider>
      </ApolloProvider>
    </MobxProvider>
  );
}

const RootWithLD = withLDProvider({
  clientSideID: PublicEnv.launchDarklyClientId,
  options: {
    sendLDHeaders: false, // Disable custom headers to eliminate OPTIONS preflight for CORS
    // Configure relay proxy endpoints (SDK v3.x uses baseUrl, streamUrl, eventsUrl)
    ...(PublicEnv.launchDarklyBaseUri && { baseUrl: PublicEnv.launchDarklyBaseUri }),
    ...(PublicEnv.launchDarklyStreamUri && { streamUrl: PublicEnv.launchDarklyStreamUri }),
    ...(PublicEnv.launchDarklyEventsUri && { eventsUrl: PublicEnv.launchDarklyEventsUri }),
  },
  reactOptions: { useCamelCaseFlagKeys: false },
})(Root);

export default RootWithLD;
